// extracted by mini-css-extract-plugin
export var container = "_5j-0";
export var infoButton = "_5j-1";
export var label = "_5j-3";
export var labelExpanded = "_5j-4";
export var price = "_5j-5";
export var priceExpanded = "_5j-6";
export var title = "_5j-2";